let data = [
  {
    children: [],
    label: 'Probability of receiving a transplant',
    markers: 'txCenters',
    organs: ['single', 'multi'],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '1'
  }, {
    children: [],
    label: '% of declined offers for quality reasons',
    markers: 'txCenters',
    organs: [],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '2'
  }, {
    children: [],
    label: '% of accepted offers of low quality organs',
    markers: 'txCenters',
    organs: [],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '4'
  }, {
    children: [],
    label: '% of accepted offers of medium quality organs',
    markers: 'txCenters',
    organs: [],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '5'
  }, {
    children: [],
    label: '% of accepted offers of high quality organs',
    markers: 'txCenters',
    organs: [],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '6'
  }, {
    children: [],
    label: 'Average cold-ischemic time of transplants',
    markers: 'txCenters',
    organs: ['single', 'multi'],
    regions: [ 'opo', 'unos' ],
    legend: 'stat7',
    unit_precision: 100,
    value: '7'
  }, {
    children: [],
    label: 'Average waiting time of a recipient who received a transplant',
    markers: 'txCenters',
    organs: ['single', 'multi'],
    regions: [ 'opo', 'unos' ],
    legend: 'stat8',
    value: '8'
  }, {
    children: [
      {
        value: '9_1',
        label: 'After 1 year'
      }, {
        value: '9_3',
        label: 'After 3 year'
      }, {
        value: '9_5',
        label: 'After 5 year'
      }
    ],
    label: 'Post-mortality recipient rate of a recipient who received a transplant',
    markers: 'txCenters',
    organs: ['single', 'multi'],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '9'
  }, {
    children: [
      {
        value: '10_1',
        label: 'After 1 year'
      }, {
        value: '10_3',
        label: 'After 3 year'
      }, {
        value: '10_5',
        label: 'After 5 year'
      }
    ],
    label: 'Graft failure for a transplant',
    markers: 'txCenters',
    organs: ['single', 'multi'],
    regions: [ 'opo', 'unos' ],
    legend: 'percent',
    value: '10'
  }, {
    children: [],
    label: '% of unused organs',
    markers: 'hospitals',
    organs: [],
    regions: [ 'state' ],
    legend: 'percent',
    value: '11'
  }, {
    children: [],
    label: '% of unused organs for quality reasons',
    markers: 'hospitals',
    organs: [],
    regions: [ 'state' ],
    legend: 'percent',
    value: '12'
  }
]

data.find = function (id, subId) {
  let cnt = this.length
  for (let i = 0; i < cnt; i++) {
    if (this[i].value === id) {
      return this[i]
    }
  }
  return null
}

export default data



// WEBPACK FOOTER //
// ./src/options/statistics.js